import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';

import { DataGridComponent } from './data-grid.component';
import { ColumnTemplatePipe } from './data-grid.pipe';
import { RouterModule } from '@angular/router';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DateRangeFilterComponent } from './date-range-filter.component';
import { LoadingSpinnerOverlayComponent } from '../loading-spinner-overlay/loading-spinner-overlay.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { UploadModule } from '@progress/kendo-angular-upload';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonGroupModule,
        ButtonsModule,
        ReactiveFormsModule,
        GridModule,
        ExcelModule,
        SwitchModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        NumericTextBoxModule,
        MatTooltipModule,
        MatButtonModule,
        MatButtonToggleModule,
        RouterModule,
        DateInputsModule,
        UploadModule,
        TooltipModule
    ],
    declarations: [
        DataGridComponent,
        DateRangeFilterComponent,
        ColumnTemplatePipe,
        LoadingSpinnerOverlayComponent
    ],
    exports: [
        DataGridComponent,
        LoadingSpinnerOverlayComponent,
        ColumnTemplatePipe
    ],
    providers: [
    ]
})
export class DataGridModule { }
